module.exports = __webpack_public_path__ + "static/niluohe-6d4005747ac5291b4af638080e3fb354.jpg";